import React from "react";
import "./Login.scss";
import Image from "../../components/image/Image";
import { AppIcons } from "../../data/appIcons";
import LoginForm from "../../features/login/Login";

const LoginPage = () => {
  return (
    <div className="main-login-section">
      <div className="min-h-full flex items-center justify-center w-full login-wrapper">

        <div className="login-main-bg">
          <div className="">
            <Image
              imagePath={AppIcons.logoImage}
              imgCustomClassName="open-bar"
              altText="Icon"
            ></Image>

          </div>
          <div>
            <LoginForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
